export const preferred_contact_method_options = [
    'Any',
    'Telephone',
    'Email',
    'SMS',
];
export const preferred_contact_time_options = [
    '09:00 - 10:00',
    '10:00 - 11:00',
    '11:00 - 12:00',
    '12:00 - 13:00',
    '13:00 - 14:00',
    '14:00 - 15:00',
    '15:00 - 16:00',
    '16:00 - 17:00',
    '17:00 - 18:00',
    '18:00 - 19:00',
    '19:00 - 20:00',
];



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/statics.js